<template>
    <div class="flex-col item-height">
        <div class="flex-row top-bar">
            <span class="iconfont iconarrowleft-outline" style="font-size: 25px;" @click="goBack"></span>
            <!-- <span class="iconfont iconPencil" style="font-size: 1rem;" @click="showEdit">{{editString}}</span> -->
            <van-icon name="edit" size="1.0rem" @click="showEdit"> {{editString}}</van-icon>
        </div>
        <label class="title-lable">{{ $t('userPEVC') }}</label>
        <div class="div-search">

            <van-search v-model="searchTxt" show-action placeholder="请输入搜索关键词" @search="onSearch">
                <template #action>
                    <div @click="onSearch">搜索</div>
                </template>
            </van-search>
        </div>
        <div class="flex-row title-info">
            <span>{{totalCount}}条关系</span>
            <div>
                <van-dropdown-menu>
                    <van-dropdown-item v-model="sortValue" :options="sortOption" @change="sortList" />
                </van-dropdown-menu>
            </div>
        </div>
        <div class="split-info" />
        <div class="list-content" id='list-content'>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad(true)">
                <div class="list-item" v-for="item in itemList" :key="item.id">
                    <div class="flex-row-between">
                        <div @click="goRelationshipInfo(item)">
                            <relationship-item v-bind:item="item"></relationship-item>
                        </div>
                        <van-checkbox v-if="isEdit" v-model="item.itemChecked" checked-color="#ee0a24"></van-checkbox>
                    </div>
                    <div class="split-info" />
                </div>
            </van-list>
        </div>
        <van-action-sheet v-model="isEdit" :actions="actions" :overlay="false" :lock-scroll="false" @select="onActionSelect" />
    </div>
</template>

<script>
import webService from "../../network/webService";
import _ from "lodash";
import common from "../../common/common";
import commonStyle from "../../styles/common.scss";
import userInfo from "@common/loginInfo";
import scollerLocation from "@/common/scollerLocation";
import { ref } from "vue";
import RelationshipItem from "../../components/common/RelationshipItem.vue";
export default {
    name: "RelationshipList",
    components: {
        RelationshipItem,
    },
    data() {
        return {
            searchTxt: "",
            itemList: [],
            loading: false,
            finished: false,
            totalCount: 0,
            currentPage: 0,
            sortValue: 0,
            isEdit: false,
            editString: "操作",
            sortOption: [
                {
                    text: "按时间排序",
                    value: 0,
                },
                {
                    text: "按关系深度降序",
                    value: 1,
                },
            ],
            userId: userInfo.userToken.userId,
            actions: [
                {
                    id: 1,
                    name: "删除",
                    color: "#D04a02",
                },
                {
                    id: 2,
                    name: "全选",
                    color: "dimgrey",
                },
            ],
        };
    },
    created() {},
    activated() {
        scollerLocation.recoverLocation("list-content");
    },
    beforeRouteLeave(to, from, next) {
        var orgMemberList = document.querySelector("#list-content");
        if (orgMemberList) {
            scollerLocation.saveLocation("list-content", orgMemberList);
        }
        next();
    },
    methods: {
        onLoad(isAdd) {
            //this.isEdit = false;
            //this.editString = '操作';
            if (!this.isEdit) {
                this.requestPageData(isAdd);
            }
        },
        onSearch(){

            this.currentPage = 0;
            this.itemList = [];
            this.requestPageData(false);
        },
        requestPageData(isAdd) {
            var param = {
                PageSize: 10,
                Page: this.currentPage,
                UserId: this.userId,
                OrderType: this.sortValue,
                SearchTxt:this.searchTxt
            };
            webService.getMyRelationships(param).then((res) => {
                res.data.data.forEach((m) => {
                    m.itemChecked = false;
                });
                common.procssData_myRelationship(this, res.data.data, isAdd);
                this.totalCount = res.data.totalCount;
            });
        },
        sortList(value) {
            this.sortValue = value;
            this.currentPage = 0;
            this.itemList = [];
            this.requestPageData(false);
        },
        goBack() {
            this.$router.push({
                path: "/home/userInfo",
            });
        },
        goRelationshipInfo(item) {
            console.log("goRelationshipInfo");
            if (!item.passed) {
                this.$toast.fail("您的关系正在由管理员审核中");
                return;
            }
            if (item.isCompanyContact) {
                this.$router.push({
                    path: "/contractorDetailCompany",
                    query: {
                        id: item.peContactId,
                        editId: item.id,
                    },
                });
            } else {
                //机构
                this.$router.push({
                    path: "/contractorDetail",
                    query: {
                        id: item.peContactId,
                        editId: item.id,
                    },
                });
            }
        },
        showEdit() {
            this.isEdit = !this.isEdit;
            if (this.isEdit) {
                this.editString = "取消";
            } else {
                this.editString = "操作";
                //取消选中的数据
                this.itemList.forEach((m) => {
                    m.itemChecked = false;
                });
            }
        },
        onActionSelect(item) {
            if (item.id == 2) {
                this.itemList.forEach((m) => {
                    m.itemChecked = true;
                });
            }
            if (item.id == 1) {
                this.deleteItems();
            }
        },
        deleteItems() {
            var deleteList = _.filter(this.itemList, ["itemChecked", true]);
            var deleteListIds = _.map(deleteList, "id");
            webService.deleteRelationshipsByIds(deleteListIds).then(() => {
                this.currentPage = 0;
                this.isEdit = false;
                this.editString = "操作";
                this.onLoad(false);
            });
        },
    },
};
</script>


<style lang="scss" scoped>
.top-bar {
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
}
.title-info {
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem 0 1rem;
}
.title-lable {
    padding: 0 1rem;
    font-size: 26px;
    color: #2d2d2d;
}
.list-item {
    padding: 0.5rem 1rem;
}
.contact-info {
    font-size: medium;
    font-weight: bold;
    padding: 0.5rem;
}
.deep-info {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 14px;
    color: darkgray;
}
.org-info {
    padding: 0.5rem 0.5rem 1rem 0.5rem;
    font-size: 15px;
}
.list-content {
    flex: 1;
    overflow: auto;
}
.div-search{
    padding-right: 14px;
}
/deep/ .van-dropdown-menu__bar {
    box-shadow: none;
}
/deep/ .van-action-sheet__content {
    display: flex;
}
/deep/ .van-search__action {
    background-color: #f7f8fa;
}
/deep/ .van-search__action:active {
    background-color: #f7f8fa;
}
.split-info {
    height: 5px;
    margin: 0 -1rem;
}
</style>


// WEBPACK FOOTER //
// src/views/profile/RelationshipList.vue